import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef, useId } from 'react';
import { getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { Help } from '../Help/index.esm.js';
import 'react-i18next';
import '@skatteetaten/ds-buttons';
import '@skatteetaten/ds-icons';
import './styles.css';


var styles = {
    "fieldset": "Fieldset-module_fieldset__iA1w9",
    "fieldset_hasSpacing": "Fieldset-module_fieldset_hasSpacing__uuLKD",
    "legend": "Fieldset-module_legend__emT8f",
    "legend_required": "Fieldset-module_legend_required__Dw-NK",
    "legendWithMarkup_required": "Fieldset-module_legendWithMarkup_required__FlX4p",
    "legendNoMarginBottom": "Fieldset-module_legendNoMarginBottom__IBawP",
    "contentContainer": "Fieldset-module_contentContainer__85ubc",
    "contentContainerNoMarginTop": "Fieldset-module_contentContainerNoMarginTop__wmY0Z",
    "srOnly": "Fieldset-module_srOnly__HcrLB"
};

const Fieldset = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), classNames, lang, 'data-testid': dataTestId, description, helpSvgPath, helpText, legend, titleHelpSvg, disabled, form, hasSpacing, hideLegend, showRequiredMark, onHelpToggle, children }, ref)=>{
    const uniqueLegendId = `legendId-${useId()}`;
    const legendId = uniqueLegendId;
    if (legend === '') {
        console.error('Fieldset - Empty legend is not recommended. Set hideLegend to false if legend prop exists but is an empty string https://html.spec.whatwg.org/multipage/form-elements.html#the-legend-element');
    }
    let requiredMarkClassName = '';
    if (showRequiredMark) {
        requiredMarkClassName = typeof legend === 'string' ? styles.legend_required : styles.legendWithMarkup_required;
    }
    const hasSpacingClassName = hasSpacing ? styles.fieldset_hasSpacing : '';
    const hideLegendClassName = hideLegend ? styles.srOnly : '';
    const noMarginBottomLegendClassName = description || helpText ? styles.legendNoMarginBottom : '';
    const noMarginTopContentContainerClassName = hideLegend ? styles.contentContainerNoMarginTop : '';
    const legendClassName = `${styles.legend} ${requiredMarkClassName} ${hideLegendClassName} ${noMarginBottomLegendClassName} ${classNames?.legend ?? ''}`.trim();
    return /*#__PURE__*/ jsxs("fieldset", {
        ref: ref,
        id: id,
        "data-testid": dataTestId,
        className: `${styles.fieldset} ${hasSpacingClassName} ${className}`.trim(),
        lang: lang,
        disabled: disabled,
        form: form,
        children: [
            /*#__PURE__*/ jsx("legend", {
                id: legendId,
                className: styles.srOnly,
                children: legend
            }),
            /*#__PURE__*/ jsx("div", {
                className: legendClassName,
                "aria-hidden": 'true',
                children: legend
            }),
            /*#__PURE__*/ jsx(Help, {
                classNames: classNames,
                helpSvgPath: helpSvgPath,
                helpText: helpText,
                hideHelp: hideLegend,
                targetId: legendId,
                titleHelpSvg: titleHelpSvg,
                description: description,
                onHelpToggle: onHelpToggle
            }),
            /*#__PURE__*/ jsx("div", {
                className: `${styles.contentContainer} ${noMarginTopContentContainerClassName}`.trim(),
                children: children
            })
        ]
    });
});
Fieldset.displayName = 'Fieldset';

export { Fieldset };
